"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInputRange = require("react-input-range");

var _reactInputRange2 = _interopRequireDefault(_reactInputRange);

var _reactBootstrap = require("react-bootstrap");

require("./NumberRangeFilter.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NumberRangeFilter = (_temp = _class = function (_Component) {
  _inherits(NumberRangeFilter, _Component);

  _createClass(NumberRangeFilter, null, [{
    key: "getDefaultQuery",
    value: function getDefaultQuery(props) {
      var _ref;

      var maxValue = props.maxValue,
          minValue = props.minValue,
          param = props.param;

      var defaultValue = props.defaultValue || [minValue, maxValue];
      return _ref = {}, _defineProperty(_ref, param + "_0", defaultValue[0]), _defineProperty(_ref, param + "_1", defaultValue[1]), _ref;
    }
  }, {
    key: "getCurrentQuery",
    value: function getCurrentQuery(props, context) {
      var _ref2;

      var _NumberRangeFilter$ge = NumberRangeFilter.getCurrentValue(props, context),
          _NumberRangeFilter$ge2 = _slicedToArray(_NumberRangeFilter$ge, 2),
          from = _NumberRangeFilter$ge2[0],
          to = _NumberRangeFilter$ge2[1];

      var param = props.param;

      return _ref2 = {}, _defineProperty(_ref2, param + "_0", from), _defineProperty(_ref2, param + "_1", to), _ref2;
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue(props, context) {
      var query = context.location.query;
      var maxValue = props.maxValue,
          minValue = props.minValue,
          param = props.param;

      var defaultValue = props.defaultValue || [minValue, maxValue];
      return [query[param + "_0"] || defaultValue[0], query[param + "_1"] || defaultValue[1]];
    }
  }]);

  function NumberRangeFilter(props, context) {
    _classCallCheck(this, NumberRangeFilter);

    var _this = _possibleConstructorReturn(this, (NumberRangeFilter.__proto__ || Object.getPrototypeOf(NumberRangeFilter)).call(this, props, context));

    _initialiseProps.call(_this);

    var _NumberRangeFilter$ge3 = NumberRangeFilter.getCurrentValue(_this.props, _this.context),
        _NumberRangeFilter$ge4 = _slicedToArray(_NumberRangeFilter$ge3, 2),
        from = _NumberRangeFilter$ge4[0],
        to = _NumberRangeFilter$ge4[1];

    _this.state = {
      from: from,
      to: to
    };
    return _this;
  }

  _createClass(NumberRangeFilter, [{
    key: "renderPopover",
    value: function renderPopover() {
      var _props = this.props,
          formatLabel = _props.formatLabel,
          maxValue = _props.maxValue,
          minValue = _props.minValue,
          step = _props.step;
      var _state = this.state,
          from = _state.from,
          to = _state.to;


      return _react2.default.createElement(
        _reactBootstrap.Popover,
        {
          className: "NumberRangeFilter-popover",
          id: "range-filter-" + minValue + "-" + maxValue },
        _react2.default.createElement(
          "div",
          { className: "NumberRangeFilter-content" },
          _react2.default.createElement(
            "div",
            { className: "NumberRangeFilter-control" },
            _react2.default.createElement(_reactInputRange2.default, {
              formatLabel: formatLabel || this.formatLabel,
              maxValue: maxValue,
              minValue: minValue,
              onChange: this.handleRangeChange,
              step: step,
              value: {
                min: parseFloat(from),
                max: parseFloat(to)
              } })
          ),
          _react2.default.createElement(
            "div",
            { className: "NumberRangeFilter-buttons clearfix" },
            _react2.default.createElement(
              "button",
              {
                className: "btn btn-xs btn-default pull-right",
                onClick: this.handleCancel,
                type: "button" },
              "Cancel"
            ),
            _react2.default.createElement(
              "button",
              {
                className: "btn btn-xs btn-success pull-left",
                onClick: this.handleApply,
                type: "button" },
              "Apply"
            )
          )
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          filterLabel = _props2.children,
          className = _props2.className;
      var _state2 = this.state,
          from = _state2.from,
          to = _state2.to;


      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          overlay: this.renderPopover(),
          placement: "bottom",
          rootClose: true,
          trigger: "click" },
        _react2.default.createElement(
          "div",
          { className: (0, _classnames2.default)("erg-components-NumberRangeFilter", className) },
          _react2.default.createElement(
            "label",
            { className: "erg-margin-right-5" },
            filterLabel,
            ":"
          ),
          _react2.default.createElement(
            "span",
            { className: "value" },
            from + " - " + to
          )
        )
      );
    }
  }]);

  return NumberRangeFilter;
}(_react.Component), _class.displayName = "NumberRangeFilter", _class.contextTypes = {
  location: _propTypes2.default.object.isRequired
}, _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.arrayOf(_propTypes2.default.number),
  formatLabel: _propTypes2.default.func,
  maxValue: _propTypes2.default.number.isRequired,
  minValue: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func,
  param: _propTypes2.default.string.isRequired,
  precision: _propTypes2.default.number,
  step: _propTypes2.default.number,
  to: _propTypes2.default.string
}, _class.defaultProps = {
  step: 1,
  precision: 1
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleApply = function () {
    var _extends2;

    var _context$location = _this2.context.location,
        query = _context$location.query,
        pathname = _context$location.pathname;
    var _props3 = _this2.props,
        onChange = _props3.onChange,
        param = _props3.param;
    var _state3 = _this2.state,
        from = _state3.from,
        to = _state3.to;


    onChange({
      pathname: _this2.props.to || pathname,
      query: _extends({}, query, (_extends2 = {}, _defineProperty(_extends2, param + "_0", from), _defineProperty(_extends2, param + "_1", to), _extends2))
    });
  };

  this.handleCancel = function () {
    var _extends3;

    var _context$location2 = _this2.context.location,
        query = _context$location2.query,
        pathname = _context$location2.pathname;
    var _props4 = _this2.props,
        maxValue = _props4.maxValue,
        minValue = _props4.minValue,
        onChange = _props4.onChange,
        param = _props4.param;

    var _ref3 = _this2.props.defaultValue || [minValue, maxValue],
        _ref4 = _slicedToArray(_ref3, 2),
        from = _ref4[0],
        to = _ref4[1];

    _this2.setState({ from: from, to: to });

    onChange({
      pathname: _this2.props.to || pathname,
      query: _extends({}, query, (_extends3 = {}, _defineProperty(_extends3, param + "_0", undefined), _defineProperty(_extends3, param + "_1", undefined), _extends3))
    });
  };

  this.handleRangeChange = function (component, _ref5) {
    var min = _ref5.min,
        max = _ref5.max;

    _this2.setState({
      from: +min.toFixed(_this2.props.precision),
      to: +max.toFixed(_this2.props.precision)
    });
  };

  this.formatLabel = function (num, _ref6) {
    var labelPrefix = _ref6.labelPrefix,
        labelSuffix = _ref6.labelSuffix;
    return "" + labelPrefix + num.toFixed(_this2.props.precision) + labelSuffix;
  };
}, _temp);
exports.default = NumberRangeFilter;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/filters/NumberRangeFilter.js
 ** module id = 794
 ** module chunks = 0
 **/